import { ThunkAction } from 'redux-thunk'
import store, { RootState } from '..'
import { cardApi } from '../../apis'
import { CardEntity, CardFilter } from '../../models'
import {
  CardAction,
  SET_CARDS,
  SET_CARDS_LOADED,
  SET_CARD_FILTER,
  SET_SELECTED_CARD_ID,
  SET_SHOW_PAY_IN_MODAL,
  SET_TOTAL_CARDS,
} from '../types'
import { loadProfile } from './authAction'

export const setCards = (cards: CardEntity[]): CardAction => ({
  type: SET_CARDS,
  payload: cards,
})

export const setTotalCards = (total: number): CardAction => ({
  type: SET_TOTAL_CARDS,
  payload: total,
})

export const setCardsLoaded = (loaded: boolean): CardAction => ({
  type: SET_CARDS_LOADED,
  payload: loaded,
})

export const loadCards = (): ThunkAction<void, RootState, null, CardAction> => {
  return async (dispatch) => {
    try {
      dispatch(setCardsLoaded(false))
      const resp = await cardApi.getCards(store.getState().card.cardFilter)
      dispatch(setCards(resp.data.data))
      dispatch(setTotalCards(resp.data.totalElement))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await cardApi.getCards(store.getState().card.cardFilter)
        dispatch(setCards(resp.data.data))
        dispatch(setTotalCards(resp.data.totalElement))
      }
    } finally {
      dispatch(setCardsLoaded(true))
    }
  }
}

export const setCardFilter = (filter: CardFilter): CardAction => ({
  type: SET_CARD_FILTER,
  payload: filter,
})

export const setSelectedCardId = (id?: string): CardAction => ({
  type: SET_SELECTED_CARD_ID,
  payload: id,
})

export const setShowPayInModal = (visible: boolean): CardAction => ({
  type: SET_SHOW_PAY_IN_MODAL,
  payload: visible,
})
